module.exports = __webpack_public_path__ + "static/media/griffith.0284e54b.png";